module.exports = __webpack_public_path__ + "img/bookmark.e2f620e8.svg";